import { createSelector } from "reselect";

import { AppState } from "../rootReducer";

const getPending = (state: AppState) => state.schemaReducer.pending;

const getSchemaData = (state: AppState) => state.schemaReducer.schemaSelection;

const getError = (state: AppState) => state.schemaReducer.error;

export const getSchemaSelectionSelector = createSelector(getSchemaData, (schemaData) => schemaData);

export const getPendingSelector = createSelector(getPending,(pending) => pending);

export const getErrorSelector = createSelector(getError, (error) => error);